import { Injectable } from "@angular/core";
import { BehaviorSubject, throwError } from "rxjs";
import { UtenteLoggato } from "../../login/login.model";

@Injectable()
export class UsersService {

    private _utente$ = new BehaviorSubject<UtenteLoggato>({} as UtenteLoggato);

    constructor() { }

    updateUtente(utente: UtenteLoggato) {
        this._utente$.next(utente);
    }

    get utente(): BehaviorSubject<UtenteLoggato> {
        return this._utente$;
    }


    onError(err) {

        return throwError("Errore server side");
    }
}